import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_592svxunwb: FaireBrandEntity = {
  token: "b_592svxunwb",
  type: "brand",
  name: "Tika",
  avatarUrl:
    "https://cdn.faire.com/fastly/2cfb2c1e791250f22d9e3e8e1e164d31867dc658b782657ce6269570e3fe1ddb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b64374fdd60c2a2d771e1a991d616db7c901f31f1bc394deec29a69b39a92218.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2cfb2c1e791250f22d9e3e8e1e164d31867dc658b782657ce6269570e3fe1ddb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b64374fdd60c2a2d771e1a991d616db7c901f31f1bc394deec29a69b39a92218.jpeg",
  location: "Trinidad, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 182,
  isInsider: true,
  description:
    "Located in the small town of Trinidad on Northern California's Redwood Coast, Tika offers an eclectic assortment of beads, jewelry and textiles from around the world.  \n\nTika's owners, Ellen Markham and Bill Boss, have a passion for supporting small fair trade businesses. They travel extensively to work with artisans around the globe to design and craft unique beads and jewelry.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.004Z",
    importedBy: "entity-db-cli",
  },
};
